export default function CompletedDocument() {
  return {
    template: require('./completed-document.html'),
    scope: {
      document: '=',
      permissions: '<',
      hasActiveDocuments: '=',
      isNavantaUser: '=',
    },
    controller: 'CompletedPmDocumentController',
    controllerAs: 'completedDocumentVM',
    bindToController: true,
    replace: true,
  };
}
